// constants/Colors.js
export const Colors = {
  PRIMARY: "#FF8C42",           // Orange accent
  SECONDARY_BLUE: "#0e6bf8",    // Brand blue
  LIGHT_BLUE: "#02c8ff",        // Light blue
  WHITE: "#FFFFFF",
  GRAY: "#9E9E9E",
  LIGHT_GRAY: "#F5F5F5",
  BORDER_GRAY: "#E0E0E0",
  TEXT_DARK: "#333333",
  TEXT_LIGHT: "#666666",
  STAR_YELLOW: "#FFD700",
  CARD_BACKGROUND: "#FFFFFF",
  GRADIENT_START: "#0e6bf8",
  GRADIENT_END: "#02c8ff",
  ICON_INACTIVE: "#B0B0B0",
  RED: "#DC3545",
  SUCCESS: "#28a745",
  WARNING: "#ffc107",
  INFO: "#17a2b8",

  // Operator status colors (moved from CSS)
  STATUS_ACTIVE:   "#4caf50",
  STATUS_BUSY:     "#ff9800",
  STATUS_INACTIVE: "#9c27b0",
  STATUS_OFFLINE:  "#f44336",
};